import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TicketButtonComponent } from '../../../../../shared/components/button/component/button.component';
import { Ticket } from '../../../../../shared/models/ticket';
import { PurchaseFormService } from '../../../../../services/purchase-form.service';
import { TranslateModule } from '@ngx-translate/core';
import { PricePipe } from "../../../../../services/utility/price.pipe";
import { Utility } from '../../../../../services/utility/util';

@Component({
  selector: 'app-passenger-types',
  standalone: true,
  imports: [CommonModule, TicketButtonComponent, TranslateModule, PricePipe],
  templateUrl: './passenger-types.component.html',
  styleUrls: ['./passenger-types.component.css'],
})
export class PassengerTypesComponent {
  @Input() locale: string = 'da-DK';

  tickets$: Observable<Ticket[]>;
  isExpanded: boolean = false;

  constructor(private formService: PurchaseFormService, private utility: Utility) {
    this.tickets$ = this.formService.tickets$;
  }

  getPassengerLabel(ticket: Ticket): string {
    const customLabel = this.utility.getCustomPassengerLabel(
      'web.' + ticket.passengerType.toLowerCase(),
      ticket.overriddenPassengerTypes,
      this.locale
    );
    return customLabel || ('web.' + ticket.passengerType.toLowerCase());
  }

  increase(ticket: Ticket): void {
    this.formService.increase(ticket);
  }

  decrease(ticket: Ticket): void {
    this.formService.decrease(ticket);
  }

  trackByType(index: number, ticket: Ticket): string | number {
    return ticket.id;
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }
}